import { inputTime } from './externals/inputTime';
import { reactDayPicker } from './externals/reactDayPicker';

export const styles = {
  global: () => ({
    ...reactDayPicker,
    ...inputTime,
  }),
};
